const settingsRoutes = {
	name: 'settings',
	path: '/settings',
	meta: { requiresAuth: true, permissions: ['settings.index'] },
	component: () => import('#modules/settings/SettingsModule.vue'),
	children: [
		{
			name: 'settings.api',
			path: 'api',
			redirect: { name: 'settings.api.index' },
			children: [
				{
					name: 'settings.api.index',
					path: '',
					meta: { permissions: ['settings.apiconnections.index'] },
					component: () => import('#modules/settings/pages/api/APIConnectionsIndex.vue'),
				},
				{
					name: 'settings.api.show',
					path: ':APIId(\\d+)',
					meta: { permissions: ['settings.apiconnections.show'] },
					component: () => import('#modules/settings/pages/api/APIConnectionPage.vue'),
					props: { isEdit: false },
				},
				{
					name: 'settings.api.edit',
					path: ':APIId(\\d+)/edit',
					meta: { permissions: ['settings.apiconnections.update'] },
					component: () => import('#modules/settings/pages/api/APIConnectionPage.vue'),
					props: { isEdit: true },
				},
				{
					name: 'settings.api.log',
					path: 'logs/:APIId(\\d+)',
					component: () => import('#modules/settings/pages/api/APILogPage.vue'),
				},
			],
		},
		{
			name: 'settings.languages',
			path: 'languages',
			redirect: { name: 'settings.languages.index' },
			children: [
				{
					name: 'settings.languages.index',
					path: '',
					meta: { permissions: ['settings.languages.index'] },
					component: () => import('#modules/settings/pages/LanguagesIndex.vue'),
				},
				{
					name: 'settings.languages.create',
					path: 'create',
					meta: { permissions: ['settings.languages.create'] },
					props: { isNew: true, isEdit: true },
					component: () => import('#modules/settings/pages/LanguagePage.vue'),
				},
				{
					name: 'settings.languages.show',
					path: ':languageId(\\d+)',
					meta: { permissions: ['settings.languages.show'] },
					props: { isNew: false, isEdit: false },
					component: () => import('#modules/settings/pages/LanguagePage.vue'),
				},
				{
					name: 'settings.languages.edit',
					path: ':languageId(\\d+)/edit',
					meta: { permissions: ['settings.languages.update'] },
					props: { isNew: false, isEdit: true },
					component: () => import('#modules/settings/pages/LanguagePage.vue'),
				},
			],
		},
		{
			name: 'settings.roles',
			path: 'roles',
			redirect: { name: 'settings.roles.index' },
			children: [
				{
					name: 'settings.roles.index',
					path: '',
					meta: { permissions: ['settings.roles.index'] },
					component: () => import('#modules/settings/pages/RolesIndex.vue'),
				},
				{
					name: 'settings.roles.create',
					path: 'create',
					meta: { permissions: ['settings.roles.create'] },
					component: () => import('#modules/settings/pages/RolePage.vue'),
					props: { isNew: true, isEdit: true },
				},
				{
					name: 'settings.roles.show',
					path: ':roleId(\\d+)',
					meta: { permissions: ['settings.roles.show'] },
					component: () => import('#modules/settings/pages/RolePage.vue'),
					props: { isNew: false, isEdit: false },
				},
				{
					name: 'settings.roles.edit',
					path: ':roleId(\\d+)/edit',
					meta: { permissions: ['settings.roles.update'] },
					component: () => import('#modules/settings/pages/RolePage.vue'),
					props: { isNew: false, isEdit: true },
				},
			],
		},
		{
			name: 'settings.templates',
			path: 'templates',
			redirect: { name: 'settings.templates.index' },
			children: [
				{
					name: 'settings.templates.index',
					path: '',
					meta: { permissions: ['settings.presets.index'] },
					component: () => import('#modules/settings/pages/TemplatesIndex.vue'),
				},
				{
					name: 'settings.templates.create',
					path: 'create',
					meta: { permissions: ['settings.presets.create'] },
					props: { isNew: true, isEdit: true },
					component: () => import('#modules/settings/pages/TemplatePage.vue'),
				},
				{
					name: 'settings.templates.show',
					path: ':templateId(\\d+)',
					meta: { permissions: ['settings.presets.show'] },
					props: { isNew: false, isEdit: false },
					component: () => import('#modules/settings/pages/TemplatePage.vue'),
				},
				{
					name: 'settings.templates.edit',
					path: ':templateId(\\d+)/edit',
					meta: { permissions: ['settings.presets.update'] },
					props: { isNew: false, isEdit: true },
					component: () => import('#modules/settings/pages/TemplatePage.vue'),
				},
			],
		},
		{
			name: 'settings.notifications',
			path: 'notifications',
			meta: { permissions: ['settings.notifications.index'] },
			component: () => import('#modules/settings/pages/notifications/NotificationsIndex.vue'),
			children: [
				{
					name: 'settings.notifications.suppliers',
					path: 'suppliers',
					meta: { permissions: ['settings.notifications.index'] },
					component: () =>
						import('#modules/settings/pages/notifications/SuppliersNotifications.vue'),
				},
				{
					name: 'settings.notifications.registrations',
					path: 'registrations',
					meta: { permissions: ['settings.notifications.index'] },
					component: () =>
						import('#modules/settings/pages/notifications/RegistrationsNotifications.vue'),
				},
				{
					name: 'settings.notifications.sensory',
					path: 'sensory',
					meta: { permissions: ['settings.notifications.index'] },
					component: () => import('#modules/settings/pages/notifications/SensoryNotifications.vue'),
				},
				{
					name: 'settings.notifications.manuals',
					path: 'manuals',
					meta: { permissions: ['settings.notifications.index'] },
					component: () => import('#modules/settings/pages/notifications/ManualsNotifications.vue'),
				},
				{
					name: 'settings.notifications.audits',
					path: 'audits',
					meta: { permissions: ['settings.notifications.index'] },
					component: () => import('#modules/settings/pages/notifications/AuditsNotifications.vue'),
				},
				{
					name: 'settings.notifications.innovativefresh',
					path: 'innovativefresh',
					meta: { permissions: ['settings.notifications.index'] },
					component: () =>
						import('#modules/settings/pages/notifications/InnovativeFreshNotifications.vue'),
				},
				{
					name: 'settings.notifications.actions',
					path: 'actions',
					meta: { permissions: ['settings.notifications.index'] },
					component: () => import('#modules/settings/pages/notifications/ActionsNotifications.vue'),
				},
			],
		},
		{
			name: 'settings.suppliers',
			path: 'supplier',
			meta: { permissions: ['suppliers.settings.settings'] },
			redirect: { name: 'settings.suppliers.instructions' },
			component: () => import('#modules/settings/pages/suppliers/SupplierSettings.vue'),
			children: [
				{
					name: 'settings.suppliers.instructions',
					path: 'instructions',
					component: () => import('#modules/settings/pages/suppliers/SuppliersGeneralSettings.vue'),
				},
				{
					name: 'settings.suppliers.supplierStatus',
					path: 'supplier-status',
					meta: { permissions: ['settings.relation_status.index'] },
					component: () => import('#modules/settings/pages/suppliers/SupplierStatuses.vue'),
				},
				{
					name: 'settings.suppliers.additionalFileTypes',
					path: 'additional-file-types',
					meta: { permissions: ['suppliers.settings.additional_file_types'] },
					component: () => import('#modules/settings/pages/suppliers/AdditionalFiles.vue'),
				},
				{
					name: 'settings.suppliers.certificateInstitutions',
					path: 'certificate-institutions',
					meta: { permissions: ['suppliers.settings.certificate_institutions'] },
					component: () => import('#modules/settings/pages/suppliers/CertificateInstitutions.vue'),
				},
				{
					name: 'settings.suppliers.certificateRemarks',
					path: 'certificate-remarks',
					component: () => import('#modules/settings/pages/suppliers/CertificateRemarks.vue'),
				},
				{
					name: 'settings.suppliers.certificateTypes',
					path: 'certificate-types',
					meta: { permissions: ['suppliers.settings.certificate_types'] },
					component: () => import('#modules/settings/pages/suppliers/CertificateTypes.vue'),
				},
				{
					name: 'settings.suppliers.customFields',
					path: 'custom-fields',
					meta: { permissions: ['settings.custom_fields.index'] },
					component: () => import('#modules/settings/pages/suppliers/CustomFields.vue'),
				},
				{
					name: 'settings.suppliers.labels',
					path: 'labels',
					meta: { permissions: ['suppliers.settings.labels'] },
					component: () => import('#modules/settings/pages/suppliers/LabelsPage.vue'),
				},
				{
					name: 'settings.suppliers.productCertificates',
					path: 'product-certificates',
					meta: { permissions: ['suppliers.settings.product_certificates'] },
					component: () => import('#modules/settings/pages/suppliers/ProductCertificates.vue'),
				},
				{
					name: 'settings.suppliers.productGroups',
					path: 'product-groups',
					meta: { permissions: ['suppliers.settings.product_groups'] },
					component: () => import('#modules/settings/pages/suppliers/ProductGroups.vue'),
				},
				{
					name: 'settings.suppliers.productSpecificationRequirements',
					path: 'product-specification-requirements',
					meta: { permissions: ['suppliers.settings.product_specification_requirements'] },
					component: () =>
						import('#modules/settings/pages/suppliers/ProductSpecificationRequirements.vue'),
				},
				{
					name: 'settings.suppliers.productTypes',
					path: 'product-types',
					meta: { permissions: ['suppliers.settings.product_types'] },
					component: () => import('#modules/settings/pages/suppliers/ProductTypes.vue'),
				},
				{
					name: 'settings.suppliers.sections',
					path: 'sections',
					meta: { permissions: ['suppliers.settings.sections'] },
					component: () => import('#modules/settings/pages/suppliers/QuestionnaireSections.vue'),
				},
				{
					name: 'settings.suppliers.supplierGroups',
					path: 'supplier-groups',
					meta: { permissions: ['suppliers.settings.supplier_groups'] },
					component: () => import('#modules/settings/pages/suppliers/SupplierGroups.vue'),
				},
				{
					name: 'settings.suppliers.supplierTypes',
					path: 'supplier-types',
					meta: { permissions: ['suppliers.settings.supplier_types'] },
					component: () => import('#modules/settings/pages/suppliers/SupplierTypes.vue'),
				},
			],
		},
		{
			name: 'settings.registrations',
			path: 'registrations',
			meta: { permissions: ['registrations.settings.settings'] },
			redirect: { name: 'settings.registrations.custom-fields' },
			component: () => import('#modules/settings/pages/registrations/RegistrationSettings.vue'),
			children: [
				{
					name: 'settings.registrations.custom-fields',
					path: 'custom-fields',
					component: () => import('#modules/settings/pages/registrations/CustomFields.vue'),
				},
				{
					name: 'settings.registrations.categories',
					path: 'categories',
					component: () => import('#modules/settings/pages/registrations/CategorySettings.vue'),
				},
				{
					name: 'settings.registrations.groups',
					path: 'groups',
					component: () => import('#modules/settings/pages/registrations/QuestionGroups.vue'),
				},
				{
					name: 'settings.registrations.sub-groups',
					path: 'subgroups',
					component: () => import('#modules/settings/pages/registrations/QuestionSubGroups.vue'),
				},
			],
		},
		{
			name: 'settings.manuals',
			path: 'manuals',
			component: () => import('#modules/settings/pages/manuals/ManualsSettings.vue'),
			meta: { permissions: ['manuals.settings'] },
			children: [
				{
					name: 'settings.manuals.labels',
					path: 'labels',
					component: () => import('#modules/settings/pages/manuals/ExtraLabels.vue'),
					meta: { permissions: ['manuals.settings.labels'] },
				},
			],
		},
		{
			name: 'settings.audits',
			path: 'audits',
			redirect: { name: 'settings.audits.audit-types' },
			meta: { permissions: ['audits.audits.settings'] },
			component: () => import('#modules/settings/pages/audits/AuditsSettings.vue'),
			children: [
				{
					name: 'settings.audits.audit-types',
					path: 'audit-types',
					component: () => import('#modules/audits/components/AuditTypeSettings.vue'),
				},
			],
		},
		{
			name: 'settings.sensory',
			path: 'sensory',
			component: () => import('#modules/settings/pages/sensory/SensorySettings.vue'),
			meta: { permissions: ['sensory.settings'] },
			children: [
				{
					name: 'settings.sensory.conclusions',
					path: 'conclusions',
					component: () => import('#modules/settings/pages/sensory/ConclusionIndex.vue'),
				},
			],
		},
		{
			name: 'settings.actions',
			path: 'actions',
			component: () => import('#modules/actions/pages/settings/ActionsSettings.vue'),
			meta: { permissions: ['actions.settings.index'] },
			children: [
				{
					name: 'settings.actions.priorities',
					path: 'priorities',
					component: () => import('#modules/actions/pages/settings/PriorityIndex.vue'),
				},
				{
					name: 'settings.actions.categories',
					path: 'categories',
					component: () => import('#modules/actions/pages/settings/CategoryIndex.vue'),
				},
				{
					name: 'settings.actions.customfields',
					path: 'customfields',
					component: () => import('#modules/actions/pages/settings/CustomFieldIndex.vue'),
				},
			],
		},
	],
}
export default settingsRoutes
